import ResetPasswordTypes from './ResetPassword.types';

export const resetPasswordStart = (data: any) => ({
	type: ResetPasswordTypes.RESET_PASSWORD_START,
	payload: data,
});

export const resetPasswordSuccess = (data: any) => ({
	type: ResetPasswordTypes.RESET_PASSWORD_SUCCESS,
	payload: data,
});

export const resetPasswordFailure = (error: unknown) => ({
	type: ResetPasswordTypes.RESET_PASSWORD_FAILURE,
	payload: error,
});

export const resetPasswordResponseChanged = () => ({
	type: ResetPasswordTypes.RESET_PASSWORD_RESPONSE_CHANGED,
});

export const resetPasswordResponseRestStart = () => ({
	type: ResetPasswordTypes.RESET_PASSWORD_RESPONSE_REST_START,
});
export const resetFingerprintStart = (data: any) => ({
	type: ResetPasswordTypes.RESET_FINGERPRINT_START,
	payload: data,
});

export const resetFingerprintSuccess = (data: any) => ({
	type: ResetPasswordTypes.RESET_FINGERPRINT_SUCCESS,
	payload: data,
});

export const resetFingerprintFailure = (error: unknown) => ({
	type: ResetPasswordTypes.RESET_FINGERPRINT_FAILURE,
	payload: error,
});

export const resetFingerprintResponseChanged = () => ({
	type: ResetPasswordTypes.RESET_FINGERPRINT_RESPONSE_CHANGED,
});
export const resetFingerprintResponseRestStart = () => ({
	type: ResetPasswordTypes.RESET_FINGERPRINT_RESPONSE_REST_START,
});
